// extracted by mini-css-extract-plugin
export default {"root":"uHv9uj","itemClickWrapper":"tpudRe","imageZoomBtn":"ycKKeh","sizer":"e4_Y8u","imageWrapper":"GthN0Q","imageBorder":"HNDR6U","image":"SQ6CkQ","overlay":"qNizLE"};